export const barchartI18NDe = {
    noData: "Keine Daten",
};
